import type { UUID } from '@/types/Id'
import type { EntityCompany, EntityPerson } from '@/types/library/Entity'

export const getCompanyName = (company: EntityCompany) => {
  return company.name ?? company.legal_name ?? 'Unknown Company'
}

export const cleanWebsiteUrl = (websiteUrl: string) => {
  return websiteUrl.replace(/^https?:\/\//, '').replace(/\/$/, '')
}

export const isPersonAssociatedWithCompany = (
  person: EntityPerson,
  companyId: UUID | null | undefined,
): boolean => {
  if (!companyId) {
    return false
  }

  return (
    person.entity_company_id === companyId ||
    person.affiliations.some(
      (affiliation) => affiliation.entity_company_id === companyId,
    )
  )
}

export const getPeopleAssociatedWithCompany = (
  people: EntityPerson[] | undefined,
  companyId: UUID | null | undefined,
): EntityPerson[] => {
  if (!people || !companyId) {
    return []
  }

  return people.filter((person) =>
    isPersonAssociatedWithCompany(person, companyId),
  )
}

export const getValidCompanyPrimaryContactId = (
  personId: UUID | null | undefined,
  eligiblePeople: EntityPerson[],
): UUID | null => {
  if (!personId) {
    return null
  }

  return eligiblePeople.some((person) => person.id === personId)
    ? personId
    : null
}
